module.exports = __webpack_public_path__ + "heroku-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/heroku-logo.png
// module id = 1257
// module chunks = 74